import { AdministrationEditTranslation } from 'app/area/administration/edit/constants';
import { AccessPerson } from 'app/components/access-panel/shared/types';

export interface UserEditMenuComponentProps {
  id: number;
  personId: string;
  name: string;
  technical: boolean;
  accessPerson: AccessPerson;
  loggedUserId: number;
  translation: AdministrationEditTranslation;
  fetching: boolean;
  optionsFetching: boolean;
  canDuplicate: boolean;

  validation: any;
  clearValidation: (fieldName: string) => void;

  onDelete: (id: number) => void;
  onChangePassword: (id: number, password: string, onSuccees: () => void) => void;
  onChangePersonId: (id: number, personId: string, onSuccees: () => void) => void;
  onSaveDatabaseAccount?: (id: number, password: string, onSuccees: () => void) => void;
  onResetDatabaseAccount?: (id: number, password: string, onSuccees: () => void) => void;
  onDeleteDatabaseAccount: (id: number) => void;
  onLoadUser: (id: number, updatedData?: { [key: string]: string }) => void;
  mergeUserItem: () => void;
}

export enum DatabaseAccount {
  create,
  reset
}

export interface UserEditMenuState {
  changingPassword: boolean;
  databaseAccount: DatabaseAccount;
  changingId: boolean;
}
